import type { ThemeConfig } from 'antd';

const themeConfig: ThemeConfig = {
  token: {
    fontSize: 16,
    borderRadius: 6,
  },
};

export default themeConfig; 